import { Record } from 'immutable';
import { fetchAllProgramsActions } from './program.actions';
import { actionTypes } from '../auth/auth.actions';
import * as api from '../api';

/**
 * Holds program data from Connect API.
 */
export const ProgramReducerState = Record({
  allPrograms: api.ApiCallState({}),
});

/**
 * Add or maintain program data in the store. (Location: "programs")
 * @param {object} state The starting state.
 * @param {object} action The action to apply
 */
export const programReducer = (initialState = new ProgramReducerState(), action) => {
  var state = initialState.set('allPrograms', api.apiCallReducer(initialState.get('allPrograms'),
    action, fetchAllProgramsActions));

  switch (action.type) {
    case actionTypes.LOGOUT:
    case actionTypes.INVALIDATE_CURRENT_SESSION:
    case actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
      return new ProgramReducerState();
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/programs/program.reducer.js